import React from "react";
import { Link } from "react-router-dom";

import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="footer-contact col-12 py-3 ">
            <div className="row justify-content-between ">
              <div className="col-md-4 d-flex">
                <div className="contact-icon pe-3">
                  <i className="fa fa-phone"></i>
                </div>
                <div className="contact-text">
                  <h6>0641230910</h6>
                  <p>Pon-Ned 10h-22h</p>
                </div>
              </div>
              <div className="col-md-4 d-flex">
                <div className="contact-icon pe-3">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-text">
                  <h6>smartbasic@gmail.com</h6>
                  <p>Online upiti</p>
                </div>
              </div>
              <div className="col-md-4 d-flex">
                <div className="contact-icon pe-3">
                  <i className="fa fa-map"></i>
                </div>
                <div className="contact-text">
                  <h6>Beograd, Srbija</h6>
                  <p>Republička 2A, Čukarica</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-links col-12 py-3">
            <div className="row">
              <div className="links-pages  col-sm-6">
                <h3>
                  <Link to="/" className=" text-uppercase fs-3 fw-bold">
                    <span>Smart</span>Basic
                  </Link>
                </h3>
                <ul className="navbar-nav ">
                  <li className="nav-item  ">
                    <Link className="nav-link" to=".">
                      Početna
                    </Link>
                  </li>
                  <li className="nav-item  ">
                    <Link className="nav-link" to="/courses">
                      Kursevi
                    </Link>
                  </li>
                  
                  
                  
                  <li className="nav-item ">
                    <Link className="nav-link" to="/contact">
                      Kontakt
                    </Link>
                  </li>
                  <li className="nav-item ">
                    
                      <a href='http://moodle.smartbasic.edu.rs/' target="_blank" rel="noopener noreferrer">Moodle link</a>
                    
                  </li>
                </ul>
              </div>
              <div className="links-info  col-sm-6 mt-4 mt-sm-0">
                <h3>Smart Basic</h3>
                <p>
                  Sa vama od 1999. godine. Velika prolaznost studenata na kolokvijumima i ispitima. Uvek sveži rokovi i kvalitetne skripte. Snimci časova dostupni tokom cele godine.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="footer-copyright col-12 text-center py-3 ">
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
